"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeEventListener = exports.addEventListener = void 0;
var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// A lightweight wrapper for `addEventListener` and `removeEventListener`.
// Allows us to provide fallbacks for browsers like IE8 and to stub out
// event listener methods more easily in tests (working around issues with
// stubbing and spying on window event listener methods in test browsers like
// ChromeHeadless).
/* eslint-disable max-params */
var addEventListener = exports.addEventListener = function addEventListener(target, event, callback, useCapture) {
  useCapture = (0, _isUndefined2["default"])(useCapture) ? false : useCapture;
  target.addEventListener(event, callback, useCapture);
};
var removeEventListener = exports.removeEventListener = function removeEventListener(target, event, callback, useCapture) {
  useCapture = (0, _isUndefined2["default"])(useCapture) ? false : useCapture;
  target.removeEventListener(event, callback, useCapture);
};